import { css as e } from "@microsoft/fast-element";
import { designTokens as o } from "../design-tokens.js";
const t = (r) => e`
  ${r} {
    /* Layout */
    flex-direction: column;
    align-items: stretch;
    overflow: hidden;
    padding: ${o.spacing[2]} 0;
    /* Style */
    border-radius: ${o.borderRadius.sm};
    border: ${o.borderWidth.xs} solid
      ${o.color.neutral[50]} !important;
    box-shadow: ${o.shadow.box.lg};
    background-color: ${o.color.white};
  }
`;
export {
  t as menuContainerStyles
};
